import script from "./addLeaseItemPage.vue?vue&type=script&setup=true&lang=js"
export * from "./addLeaseItemPage.vue?vue&type=script&setup=true&lang=js"

import "./addLeaseItemPage.vue?vue&type=style&index=0&id=b96636e2&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96636e2"]])

export default __exports__